import styled from 'styled-components';
import { Col, Image, Input, Modal } from 'antd';

export const ImageContainer = styled(Col)`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const CustomImage = styled(Image)`
	width: 100%;
	max-height: 45vh;
	border-radius: 6px;
`;

export const CustomTextArea = styled(Input.TextArea)`
	border-radius: 6px;
	border: 2px solid #e6e6e6;
	background-color: #ffffff;
	textarea {
		border-radius: 6px;
		padding: 8px 12px;
	}
	span {
		border: 0;
		background: transparent;
	}
`;

export const CustomModal = styled(Modal)`
	.ant-modal-content {
		min-width: 400px;
		border-radius: 30px;
	}
`;
